export class ListFreightTypesService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/pedidos/ListaTipoFrete', { params })
  }
}
